import { inject, Injectable } from '@angular/core';
import { environmentDev } from '../../../../environments/environment.dev';
import { BehaviorSubject, Observable, map, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BackendService } from '../../../core/services/backend/backend.service';
import { IField } from '../../model/i-field';
import { ListQuest } from '../lists/list-quest';
import { RdGameService } from '../games/rd-game';

@Injectable({
  providedIn: 'root'
})
export class FieldBuilder {

  http = inject(HttpClient);
  backend = inject(BackendService);
  listQuest = inject(ListQuest);

  listFields: Array<IField>;
  nowFreeFields: Array<IField>;
  nowUserListFields: Array<IField>;

  playField: Array<IField>;
  playersFieldId: any = [];
  


  loadPlayingField(notEmpty: Array<number>){
    this.loadPlayingFieldForLanguageChange(notEmpty).subscribe();
  }

  loadPlayingFieldForLanguageChange(notEmpty: Array<number>): Observable<void>{
    this.playersFieldId = [];
    return this.http.get<any>(`${this.backend.getApiUrl()}/playing-field`).pipe(
      tap( (playingField: any) => {
        this.listFields = this.isEmptyFieldsAll(playingField.playing_field, notEmpty);
        sessionStorage.setItem( 'Fields', JSON.stringify( this.listFields ) );      
      } ),
      map(() => undefined)
    );
  }

  loadField(){
    return this.http.get(`${this.backend.getApiUrl()}/playing-field`);
  }

  findField(position: number):IField{
    
    return this.listFields.find( (item: IField) => item.position === position ) as IField;
  }

  rebuildField(acFields: Array<number>): void{
    this.listFields.forEach((field: IField)=>{
      field.isEmptyField = true;
      field.style = 'hide-field';
      if(acFields.includes(field.position)){
        field.isEmptyField = false;
        field.style = 'show-field';
      }
    });
    
  }

  getListField(list: any){

    this.reNameField(list);
    this.nowUserListFields = list.userFields;
    this.nowFreeFields = list.freeFields;

  }

  reNameField(list: any){
    let reTitle: string = '';
    let reComment: string = '';
    for(let i=0;i<list.userFields.length;i++){
      reTitle = this.listFields[i].title;
      reComment = this.listFields[i].comment;
      this.listFields[i] = list.userFields[i];
      this.listFields[i].title = reTitle;
      this.listFields[i].comment = reComment;
    }
  }

  changeLinkPDF(link: string){
    return this.http.post(`${this.backend.getApiUrl()}/do_pdf/generate`,{"source_pdf": link});
  }

  chengeListFields(isChange: boolean){
    if(isChange){
      this.listFields = this.nowUserListFields;
    }else{
      this.listFields = this.nowFreeFields;
    }
  }

  isEmptyFieldsAll(fields: Array<IField>, notEmpty: Array<number>): Array<IField>{
    fields.forEach((item: IField) =>{
      // TODO потрібно буде змінювати пізніше , повязано з тим що 05,11,25 notEmpty []
      item.isEmptyField = false;
      if(notEmpty.includes(item.position)){
        item.isEmptyField = false;
      }
      
    });
    return fields;
  }

  isNotAnEmptyField(position: number): boolean{
    const result: IField = this.listFields.find( (item: IField) => item.position === position ) as IField;
    return result.isEmptyField as boolean;
  }

  settingsFieldsForUser(listQuest: Array<any>){
    // TODO поки зарез
   // this.userFillQuestField(listQuest);
  }

  //TODO це для пізнішого варіанту
  fn1(){
    if(this.listFields.length === this.listQuest.quests.length){
      for (let i =  1; i <=  this.listFields.length; i++){
       // this.listFields[i].isEmptyField = this.listQuest.quests[i].isEmpty;
      }
    }
  }

  userFillQuestField(list: Array<any>){
    // this.listFields.forEach((item: IField, index: number) =>{
    //   item.isEmptyField = true;
    //   if(list.includes(item.position)){
    //     item.isEmptyField = this.listQuest.quests[index].isEmpty;
    //   }
    // });
    // sessionStorage.setItem( 'Fields', JSON.stringify( this.listFields ) );
  }

  loadWithStorageFields(){
    this.listFields = JSON.parse( sessionStorage.getItem('Fields') as string );
  }

  // Затикачка для правильної реалізації потрібно мати два варіанта поля 1) коли ми ходимо по всіх своїх полях ( own ); 
  // 2) коли ми ходимо тільки по вільних полях
  // до 08.09 18:14 було реалізовано що ходить можна тільки по "own" та по вільних ( це була груба помилка )
  playerFields(players: any, player: any, type: string){
    let userPF: Array<IField> = [];
    let  fieldActive: any = [];
    this.listFields.forEach((fld: IField) =>{
      let uField: IField = structuredClone(fld);
    // todo + 08.09
    uField.isEmptyField = true;
    uField.style = 'hide-field';
      if(player.own.includes(fld.position) && !fld.isEmptyField){
        uField.isEmptyField = false;
        uField.style = 'show-field';
        fieldActive.push(fld.position);
      }
      // TODO це перевірка для "свободних"
      if(!player.own.includes(fld.position) && !fld.isEmptyField){
        if(players.length > 1){
          players.forEach( (lstPlr: any)=>{
            if(player.player_id !== lstPlr.player_id){
              if(lstPlr.own.includes(fld.position)){
                uField.style = 'show-field';
              }
            }
          } )
        }
      }
      userPF.push(uField);
    });
    this.playersFieldId.push({playerId: player.player_id, playerField: fieldActive});
    let allFreeField: Array<IField> = [];
    
    if(type === 'role'){
      allFreeField = this.freeFieldPlayer(players);
    }

    return   { userFields: userPF,freeFields: allFreeField };//{ userFields: userPF,freeFields: allFreeField };
  }

  // TODO поле з "вільними" ячейками
  freeFieldPlayer(players: any){
    let freeFields: Array<IField> = [];
    
    this.listFields.forEach((fld: IField) =>{
      let uField: IField = structuredClone(fld);
      if(!fld.isEmptyField){
        players.forEach( (lstPlr: any)=>{
          if(lstPlr.own.includes(fld.position)){
            uField.isEmptyField = true;
          }
        });
      }
      freeFields.push(uField);
    });

    return freeFields;
  }

  // список самих квестів
  questField: Array<any> = environmentDev.fieldQuest;
  // сектора, рівні , всіх квестів
  typeFields: Array<any> = environmentDev.fieldsList;
  // пошук поля щоб в подальщому проходить квест
  fieldSearch:any = {};
  // поля самого квесту
  fieldQuest: any;
  questSubcr$ = new BehaviorSubject(0);

  init(position: number){
    this.fnFindTypeFields(position);
    this.fnFindFieldQuest();
    this.questSubcr$.next(this.fieldQuest);
  }
  

  fnFindTypeFields(position: number){
    this.fieldSearch = {};
    this.typeFields.forEach((item: any)=>{
      item.sectors.fields.forEach((field:any) => {
        if(field.position === position){
          this.fieldSearch = field;
        }
      });
    });
  }

  fnFindFieldQuest(){
    this.fieldQuest = this.questField.find((quest: any)=> quest.type_id === this.fieldSearch.type_id);
  }
}
